export default {
    props: ['studyId'],
    data() {
        return {
            id: '',
            officeLink: 'https://view.officeapps.live.com/op/view.aspx?src=',
            url: '',
            docType: '',
            progress: '',
            token: ''
        }
    },
    methods: {
        getResourse(id) {
            // console.log('执行了', id)
            // // console.log(this.$store.state.id)
            // // console.log(this.$store.state.authority_management)
            if (this.$store.state.id != '') {
                // // console.log('id')
                this.token = this.$store.state.id
            } else {
                this.token = this.$store.state.authority_management
            }
            this.$post('resources/get', { id: id, token: this.token }).then(res => {
                // // console.log('res', res)
                this.docType = res.data.result.data;
                this.docType = this.docType.substring(this.docType.length - 4)
                //这端是pdf的
                // // console.log(this.docType)
                if (this.docType == '.pdf') {
                    this.url = this.wordUrl + res.data.result.data
                    var options = {
                        height: '813px',
                        width: '100%',
                        pdfOpenParams: { view: 'FitV', page: '0' },
                        name: "mans",
                        fallbackLink: "<p>您的浏览器暂不支持此pdf，请下载最新的浏览器</p>"
                    };
                    // // console.log( $('#example1').length)
                    PDFObject.embed(this.url, "#example1", options);

                    let win = document.getElementById('example1');
                    console.log(win);

                    this.progress = 1;
                } else {
                    this.url = this.officeLink + this.wordUrl + res.data.result.data
                }
                this.progress = 1;
                // // console.log(this.url)
            })
        },

        scroll(e) {
            console.log(e);
        },

    },
    created() {
        this.id = this.studyId
        this.getResourse(this.id)
    },
    mounted() {
        // this.getResourse(this.id)
    }
}